import utils from '@/utils/utils'

let buttonResource = () => utils.buttonResource(
  [
    // 组织管理
    'XTSZ-ZZGL-XZ', // 新增
    'XTSZ-ZZGL-SY', // 上移
    'XTSZ-ZZGL-XY', // 下移
    'XTSZ-ZZGL-CY', // 查询
    'XTSZ-ZZGL-XQ', // 详情
    'XTSZ-ZZGL-XQY-BJ', // 详情页编辑
    // 功能菜单管理
    'XTSZ-GNCDGL-XZ', // 新增
    'XTSZ-GNCDGL-SY', // 上移
    'XTSZ-GNCDGL-XY', // 下移
    'XTSZ-GNCDGL-SC', // 删除
    'XTSZ-GNCDGL-BJ', // 编辑
    // 角色管理
    'XTSZ-JSGL-XZ', // 新增
    'XTSZ-JSGL-CY', // 查询
    'XTSZ-JSGL-JSXQ-BJ', // 角色详情编辑
    // 账号管理
    'XTSZ-ZHGL-XZ', // 新增
    'XTSZ-ZHGL-CY', // 查询
    'XTSZ-ZHGL-GLQX', // 管理权限
    'XTSZ-ZHGL-DJ', // 冻结
    'XTSZ-ZHGL-ZHXQ-BJ', // 账号详情编辑
    // 预警配置
    'XTSZ-YJPZ-CY', // 查询
    'XTSZ-YJPZ-XZ', // 新增
    'XTSZ-YJPZ-DR', // 导入
    // 登录日志
    'XTSZ-RZGL-DLRZ-CY', // 查询
    'XTSZ-RZGL-DLRZ-DC', // 导出
    // 业务日志
    'XTSZ-RZGL-YWRZ-CY', // 查询
    'XTSZ-RZGL-YWRZ-DC', // 导出
    // 预警配置
    'XTSZ-YJPZ-CY',//查询
    'XTSZ-YJPZ-XZ',//新增
    'XTSZ-YJPZ-DR',//导入
    // 事项公告详情
    'GZT-SXGGXQ',//跳转详情
    // pos预收规则权限
    'YSGZ-XZ',//新增
    'YSGZ-BJ',//编辑
    'YSGZ-JY',//禁用
    'YSGZ-QY',//启用
    'YSGZ-XG',//修改有效期
    'YSGZ-SH',//审核
    'YSGZ-JJ',//拒绝
    'YSGZ-ZF'//作废
  ]
)

export default buttonResource